// @flow
import ErrorStub from './ErrorStub';

export default ErrorStub;
